import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_CLAIM_READ_PROVIDER_LIST_REQUEST: '',
  GET_CLAIM_READ_PROVIDER_LIST_SUCCESS: '',
  GET_CLAIM_READ_PROVIDER_LIST_FAILURE: '',

  GET_CLAIM_READ_WRITE_PROVIDER_LIST_REQUEST: '',
  GET_CLAIM_READ_WRITE_PROVIDER_LIST_SUCCESS: '',
  GET_CLAIM_READ_WRITE_PROVIDER_LIST_FAILURE: '',
};

types = setStoreTypeValues(types, 'claimProviderList');

export default types;
